import React, { useEffect } from 'react';
import { useAwaitControl } from 'react-redux-await-control';

import History from '~/screens/Contract/components/Tabs/History/History';
import { getContractHistory } from '~/store/contracts/actions';
import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type CardHistoryViewProps = {
  contractId: string;
  contract: any;
  onBack: () => void;
};

export function CardHistoryView({ contractId, contract, onBack }: CardHistoryViewProps) {
  const contractHistoryControl = useAwaitControl(getContractHistory);
  const events = contractHistoryControl.result();

  useEffect(() => {
    if (contract?.contract) {
      contractHistoryControl.start({
        externalId: contract.contract.externalId,
        product: contract.contract.product,
        document: contract.contract.document,
      });
    }
  }, [contract?.contract?.externalId, contract?.contract?.product, contract?.contract?.document]);

  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <History events={events} />
    </div>
  );
}
